import { FilesUploader } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, MediaFilePicker } from "ui";

import { VideoFormAtomProps } from "../VideoForm.types";

import styles from "../VideoForm.module.scss";

const ImageField = ({ control }: VideoFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.form__imagesContainer}>
      <Controller
        control={control}
        name="thumbnail"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField
            label={t("Upload Thumbnail")}
            errorMessage={error?.message}
          >
            <FilesUploader
              onSuccessUploading={onChange}
              uploadDirectoryKey={MediaDirectoryKeys.InventoryManager}
            >
              {(uploaderProps) => (
                <MediaFilePicker
                  {...uploaderProps}
                  allowedMediaTypes={[MediaType.IMAGE]}
                  value={value}
                  label={"221:118"}
                  customSize={{ width: 221, height: 118 }}
                  onDeleteMediaFile={() => onChange(null)}
                />
              )}
            </FilesUploader>
          </FormField>
        )}
      />
    </div>
  );
};

export default ImageField;
